function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  margin-top: 0.75rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  \n  ",
        "\n\n  // 반응형: 좁은 화면에서 gap 줄이기\n  @media (max-width: 400px) {\n    gap: 1rem; // 좁은 화면 기본 gap\n    ",
        "\n  }\n  @media (max-width: 350px) {\n    gap: 0.75rem; // 더 좁은 화면 기본 gap\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.25rem;\n  font-weight: ",
        ";\n  font-size: 0.8em; // 기본 글자 크기 약간 줄임 (선택적)\n  \n  color: ",
        ";\n\n  // 반응형: 매우 좁은 화면에서 숨김\n  @media (max-width: 350px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 100%;\n  left: 4rem;\n  margin-top: 0.25rem;\n  background-color: var(--theme-paper, ",
        ");\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border-radius: 0.75rem;\n  border: 1px solid var(--theme-border, ",
        ");\n  z-index: 30;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// 소셜 액션 컨테이너
export var SocialActionsContainer = styled.div(_templateObject());
// 액션 버튼 행 (Props 타입 추가 및 반응형 gap 추가)
export var ActionButtonsRow = styled.div(_templateObject1(), function(param) {
    var size = param.size;
    if (size === 'sm') return 'gap: 1rem;';
    if (size === 'lg') return 'gap: 2.5rem;';
    return 'gap: 2rem;'; // md (기본)
}, function(param) {
    var size = param.size;
    if (size === 'sm') return 'gap: 0.75rem;';
    if (size === 'lg') return 'gap: 1.5rem;';
    return 'gap: 1.25rem;'; // md (기본)
}, function(param) {
    var size = param.size;
    if (size === 'sm') return 'gap: 0.5rem;';
    if (size === 'lg') return 'gap: 1rem;';
    return 'gap: 0.75rem;'; // md (기본)
});
// 개별 액션 그룹 (Props 타입 추가)
export var ActionGroup = styled.div(_templateObject2(), function(param) {
    var small = param.small;
    return small ? 'margin-right: 0.25rem;' : '';
});
// 카운트 스팬 (반응형 추가)
export var CountSpan = styled.span(_templateObject3(), function(param) {
    var $active = param.$active;
    return $active ? '600' : '400';
}, function(param) {
    var $active = param.$active, color = param.color, theme = param.theme;
    // theme 객체가 없을 경우 기본값 사용
    var safeTheme = theme || {
        textMuted: '#6b7280',
        primary: '#3b82f6',
        success: '#10B981',
        error: '#ef4444',
        textSecondary: '#4b5563',
        isDark: false
    };
    if (!$active) return "var(--theme-text-muted, ".concat(safeTheme.textMuted, ")");
    // 다크 모드일 때는 더 밝은 색상 사용
    var isDark = (theme === null || theme === void 0 ? void 0 : theme.isDark) || false;
    switch(color){
        case 'green':
            return isDark ? "var(--theme-success-light, #34D399)" : "var(--theme-success, ".concat(safeTheme.success, ")");
        case 'red':
            return isDark ? "var(--theme-error-light, #F87171)" : "var(--theme-error, ".concat(safeTheme.error, ")");
        case 'blue':
        default:
            return isDark ? "var(--theme-primary-light, #60A5FA)" : "var(--theme-primary, ".concat(safeTheme.primary, ")");
    }
});
// 리트윗 옵션 팝업
export var RetweetOptionsPopup = styled.div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.paper;
}, function(param) {
    var theme = param.theme;
    return theme.border;
});
// 북마크 섹션 (spaced 변형용)
export var BookmarkSection = styled.div(_templateObject5());
